/* eslint-disable no-unused-vars */
export enum OptOutEnum {
  ALL = 'all',
  OPT_IN = 'optIn',
  OPT_OUT = 'optOut',
}
